import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/operators", label: "Operators" },
  { to: "/guides", label: "Guides" },
  { to: "/methodology", label: "Methodology" },
  { to: "/about", label: "About" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass shadow-[0_1px_0_rgba(0,0,0,0.04)]" : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="relative">
            <div className="w-9 h-9 rounded-full bg-terracotta flex items-center justify-center text-sand font-serif text-xl leading-none">C</div>
            <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-forest ring-2 ring-sand"></span>
          </div>
          <div className="leading-tight">
            <div className="font-serif text-xl tracking-tight">Choose <span className="text-terracotta">My Hotel</span></div>
            <div className="text-[10px] uppercase tracking-[0.24em] text-charcoal/50">US booking-source guide</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `link-underline text-sm tracking-wide ${isActive ? "text-terracotta" : "text-charcoal/80 hover:text-charcoal"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link to="/operators" data-testid="nav-cta-compare" className="btn-primary">Compare operators</Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 text-charcoal"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-white/50" data-testid="nav-mobile-menu">
          <div className="container-x py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} className="text-charcoal text-lg font-serif">
                {l.label}
              </NavLink>
            ))}
            <Link to="/operators" className="btn-primary w-full">Compare operators</Link>
          </div>
        </div>
      )}
    </header>
  );
}
